import React from "react";
import clsx from "clsx";

const Item = ({ className, name, value, deltaValue }) => {
	const formattedDelta = deltaValue != null ? `${Number(deltaValue) > 0 ? "+" : ""}${deltaValue}` : null;

	return (
		<div className={clsx("curves-change-analysis-box__data-item", className)}>
			<p>{name ? name : ""}</p>
			{/* <p>{value ? value : '沒有數據'}</p> */}
			{formattedDelta != null && (
				<p
					className={clsx("curves-change-analysis-box__data-item-delta", {
						"delta--positive": Number(deltaValue) > 0,
						"delta--negative": Number(deltaValue) < 0,
					})}
				>
					{formattedDelta}
				</p>
			)}
		</div>
	);
};

const CurvesChangeAnalysisBox = ({ data = {} }) => {
	const defaultItems = [
		{ key: "neck", className: "neck" },
		{ key: "chest", className: "chest" },
		{ key: "armLeft", className: "arm-left" },
		{ key: "armRight", className: "arm-right" },
		{ key: "waist", className: "waist" },
		{ key: "hip", className: "hip" },
		{ key: "legLeft", className: "leg-left" },
		{ key: "legRight", className: "leg-right" },
	];

	return (
		<div className={"curves-change-analysis-box"}>
			<div className={"curves-change-analysis-box__content"}>
				{defaultItems.map(({ key, className }) => {
					return <Item key={key} className={className} name={data[key]?.name} value={data[key]?.value} deltaValue={data[key]?.deltaValue} />;
				})}
			</div>
		</div>
	);
};

export default CurvesChangeAnalysisBox;
